import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../libs/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-lg text-sm font-medium shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ring-offset-background",
  {
    variants: {
      variant: {
        default: "bg-primary text-white hover:bg-sky-600 hover:text-white",
        destructive: "bg-red-600 text-white hover:bg-red-700",
        outline:
          "border border-slate-200 bg-white text-slate-700 hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700",
        secondary: "bg-slate-100 text-slate-800 hover:bg-slate-200",
        ghost: "shadow-none text-slate-600 hover:bg-sky-50 hover:text-sky-700",
        lightprimary:
          "bg-lightPrimary text-sky-700 hover:bg-sky-100 hover:text-sky-800",
        link: "text-primary underline-offset-4 hover:underline",
        filter: "bg-white text-slate-700 hover:bg-sky-50 hover:text-sky-700",
      },
      size: {
        default: "min-h-10 px-3 py-2.5",
        sm: "min-h-9 px-2.5 py-2 rounded-md",
        lg: "min-h-11 px-4 py-3 rounded-md",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
const Button = React.forwardRef(function Button(
  { className, variant, size, asChild = false, ...props },
  ref
) {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      className={cn(buttonVariants({ variant, size }), className)}
      ref={ref}
      {...props}
    />
  );
});

export { Button, buttonVariants };
